import React, { FC, Suspense, useState } from 'react';

import { Spinner } from 'src/components/spinner';

import { StyledImage, StyledOverlay, StyledVideoThumbnail } from './video-thumbnail.styled';

interface Props {
  description: string;
  thumbnail: string;
  url: string;
}

const VideoPopup = React.lazy(() => import('./video-popup'));

export const VideoThumbnail: FC<Props> = (props) => {
  const { description, thumbnail, url } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <StyledVideoThumbnail onClick={handleOpen}>
        <StyledImage src={thumbnail} alt={description} />
      </StyledVideoThumbnail>
      {isOpen && (
        <Suspense
          fallback={
            <StyledOverlay>
              <Spinner />
            </StyledOverlay>
          }
        >
          <VideoPopup url={url} isOpen={isOpen} onRequestClose={handleClose} />
        </Suspense>
      )}
    </>
  );
};
